import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Link, Redirect } from "react-router-dom";
import "react-phone-number-input/style.css";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import { Header } from "../components";
import google from "../assets/google.png";
import facebook from "../assets/Logo_facebook.svg";
import twitter from "../assets/logo_twitter.svg";
import arrow from "../assets/arrow.png";

import { ToastContainer, toast } from "react-toastify";
import { authenticate, isAuth } from "../helpers/auth";
import axios from "axios";

import { useFormik } from 'formik'

const SignUp = () => {
  const [signUpType, setsignUpType] = useState(1);
  const [value, setValue] = useState();

  const [firstName, setfirstName] = useState("");
  const [lastName, setlastName] = useState("");
  const [email, setemail] = useState("");
  const [password, setpassword] = useState("");
  const [mobile, setmobile] = useState("");

  const [name, setmargerName] = useState("");

  useEffect(() => {
    setmargerName(firstName + "  " + lastName);
  }, [firstName, lastName]);

  // Submit data backend
  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   if (name && email && password && mobile) {
  //     axios
  //       .post("https://yartirush.herokuapp.com/api/auth/register", {
  //         name,
  //         email,
  //         password,
  //         mobile,
  //       })
  //       .then((res) => {
  //         console.log(res);

  //         setfirstName("");
  //         setlastName("");
  //         setemail("");
  //         setpassword("");
  //         setmobile("");

  //         toast.success(res.data.message);
  //       })
  //       .catch((err) => {
  //         // console.log(err.response);
  //         console.log("sorrry for this");
  //         toast.error(err.response.data.errors);
  //       });
  //     // console.log(reponse);
  //   } else {
  //     toast.error("please fill all fields");
  //   }
  // };

//   const onSubmit = (values) => {
//     alert(JSON.stringify(value))
//   }
  
//   const formik = useFormik({ initialValues: { name:"", email:"", password:"", mobile:"" },
//   validateOnBlur: true,
//   onSubmit,
// })


  

  return (
    <>
      <Header />
      <Wrapper>
        <div className="sign__Wrapper">
          <div className="section-center text-center">
            <div className="sign__up_wrapper">
              <div className="sign__up_method">
                <a href="https://google.com/">
                  <div className="sign__up_google">
                    <img src={google} alt="google" />
                    Sign up with google
                  </div>
                </a>
                <a href="https://www.facebook.com/">
                  <div className="sign__up_social">
                    <img src={facebook} alt="facebook" />
                  </div>
                </a>
                <a href="https://twitter.com/">
                  <div className="sign__up_social">
                    <img src={twitter} alt="twitter" />
                  </div>
                </a>
              </div>

              <div className="signUp__type">
                <h1>I AM</h1>
                <div className="signUp__type_btn">
                  <button
                    onClick={() => setsignUpType(1)}
                    className={`heading-button ${
                      signUpType === 1 ? "active" : undefined
                    }`}
                  >
                    Individual
                  </button>
                  <button
                    onClick={() => setsignUpType(2)}
                    className={`heading-button ${
                      signUpType === 2 ? "active" : undefined
                    }`}
                  >
                    Business
                  </button>
                </div>
              </div>
              {signUpType === 1 ? (
                <form className="sign__up_form">
                  <div className="detail">
                    <h1>DETAILS</h1>
                  </div>

                  <div className="phone__inputs">
                    <PhoneInput
                      international
                      defaultCountry="US"
                      onChange={setmobile}
                      value={mobile}
                      // error={
                      //   mobile
                      //     ? isValidPhoneNumber(mobile)
                      //       ? undefined
                      //       : "Invalid phone number"
                      //     : "Phone number required"
                      // }
                      className="phoneInput"
                    />
                  </div>

                  <div className="signUp__name">
                    <input
                      type="text"
                      placeholder="First Name"
                      onChange={(e) => setfirstName(e.target.value)}
                      value={firstName}
                      name='firstName'
                    />
                    <input
                      type="text"
                      placeholder="Last Name"
                      onChange={(e) => setlastName(e.target.value)}
                      value={lastName}
                      name='lastName'
                    />
                  </div>

                  <div className="signUp__process">
                    <input
                      type="email"
                      placeholder="Email Address"
                      className="signup__mail__proc"
                      onChange={(e) => setemail(e.target.value)}
                      value={email}
                      name='email'
                    />
                    <input
                      type="password"
                      placeholder="Password"
                      className="signup__mail__proc"
                      onChange={(e) => setpassword(e.target.value)}
                      value={password}
                      name='password'
                    />
                  </div>

                  <div className="terms__checkbox">
                    <input type="checkbox" />
                    <h5>
                      I agree to the
                      <Link to="/privacy">
                        <span> T&C’s </span>
                      </Link>
                      and {"  "}
                      <Link to="/privacy">
                        <span>Privacy Policy</span>
                      </Link>
                    </h5>
                  </div>

                  {/* <Link to="/login"> */}
                  <button className="signUp__btn">
                    Create Account{"  "} <img src={arrow} alt="arrow" />
                  </button>
                  {/* </Link> */}
                </form>
              ) : undefined}

              {signUpType === 2 ? (
                <form className="sign__up_form">
                  <div className="detail__secend">
                    <h1>DETAILS</h1>
                  </div>

                  <div className="phone__inputs">
                    <PhoneInput
                      international
                      defaultCountry="US"
                      value={value}
                      onChange={setValue}
                      error={
                        value
                          ? isValidPhoneNumber(value)
                            ? undefined
                            : "Invalid phone number"
                          : "Phone number required"
                      }
                      className="phoneInput"
                    />
                  </div>

                  <div className="signUp__name">
                    <input type="text" placeholder="Business Name" />
                    {/* <input type="text" placeholder="Last Name" /> */}
                  </div>

                  <div className="signUp__process">
                    <input
                      type="email"
                      placeholder="Enter your business email address"
                      className="signup__mail__proc"
                    />
                    <input
                      type="text"
                      placeholder="Enter your EIN (Optional)"
                      className="signup__mail__proc"
                    />
                    <input
                      type="password"
                      placeholder="Password"
                      className="signup__mail__proc"
                    />
                  </div>

                  <div className="terms__checkbox">
                    <input type="checkbox" />
                    <h5>
                      I agree to the
                      <Link to="/privacy">
                        <span> T&C’s </span>
                      </Link>
                      and {"  "}
                      <Link to="/privacy">
                        <span>Privacy Policy</span>
                      </Link>
                    </h5>
                  </div>

                  <Link to="/login">
                    <button className="signUp__btn">
                      Create Account{" "}
                      <img src="../../assets/arrow.png" alt="arrow" />
                    </button>
                  </Link>
                </form>
              ) : undefined}

              <p className="wrapper__footer">
                Already have an account?
                <Link to="/login">
                  <span> Login Now</span>
                </Link>
              </p>
            </div>
          </div>
        </div>

        <div className="Svg">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
            <path
              fill="#E5EDFC"
              fill-opacity="1"
              d="M0,320L1440,64L1440,0L0,0Z"
            ></path>
          </svg>
        </div>
      </Wrapper>
    </>
  );
};

// <svg width="750" height="791" viewBox="0 0 750 791" fill="none" xmlns="http://www.w3.org/2000/svg"> <rect x="0.653931" y="402.157" width="700" height="700" rx="100" transform="rotate(-35 0.653931 402.157)" fill="#1E266D" fill-opacity="0.05"/> </svg>

const Wrapper = styled.section`
  .heading-button.active {
    border: 1.5px solid #6300ff;
    background: #6300ff;
    color: #fff;
  }
  .sign__Wrapper {
    background: #e5edfc;
    width: 100vw;
    height: 36rem;
    /* height: 40rem; */
    position: relative;
  }
  .heading-button {
    /* border: 1px solid black; */
  }

  .sign__up_wrapper {
    width: 530px;
    margin: auto;
    background: #ffffff;
    border-radius: 21px;
    text-align: left;
    padding: 25px 35px;
    z-index: 999;

    transform: translateY(60px);
  }
  .sign__Up_hero_wrap {
    background: #e5edfc;
    width: 100vw;
    height: 50rem;
  }
  .Svg {
    margin: -31px 0 142px 0;
  }
  .sign__up_header {
    text-align: left;

    h3 {
      font-family: SofiaPro;
      font-style: normal;
      font-weight: bold;
      font-size: 30px;
      line-height: 30px;
      color: #b76e79;
    }

    h5 {
      font-family: SofiaPro;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 16px;
      color: #2d3748;
      margin-top: 20px;
    }
  }

  .sign__up_method {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 400px;
    margin-top: 40px;
  }

  .sign__up_method a {
    text-decoration: none;
  }

  .sign__up_google {
    background: #6300ff;
    border-radius: 5px;
    width: 235px;
    height: 50px;
    font-family: Manrope;
    font-style: normal;
    font-weight: bold;
    font-size: 16px;
    line-height: 22px;
    color: #ffffff;
    display: flex;
    align-items: center;
    img {
      margin-left: 15.6px;
      margin-right: 15.6px;
    }
  }
  .sign__up_social {
    background: #6300ff;
    border-radius: 5px;
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    padding-left: 18px;
  }

  .signUp__type h1::before {
    content: "";
    width: 101px;
    height: 2px;
    background: #b6bbc5;
    position: absolute;
    padding: 1px;
    left: 90px;
    top: 13px;
  }
  .signUp__type h1::after {
    content: "";
    width: 101px;
    height: 2px;
    background: #b6bbc5;
    position: absolute;
    padding: 1px;
    right: 94px;
    top: 13px;
  }

  .signUp__type {
    position: relative;
    h1 {
      font-family: Nunito Sans;
      font-style: normal;
      font-weight: 800;
      font-size: 20px;
      line-height: 27px;
      text-align: center;
      color: #596278;
      margin-top: 37px;
    }
    button {
      background: #ffffff;
      border: 1.5px solid #6300ff !important;
      border: none;
      outline: none;
      box-sizing: border-box;
      border-radius: 4px;
      outline: none;
      width: 219px;
      height: 45px;
      margin-right: 10px;
      margin-top: 24px;
      font-family: Manrope;
      font-style: normal;
      font-weight: bold;
      font-size: 20px;
      line-height: 27px;
      text-align: center;
      color: #596278;
    }
  }

  .detail {
    h1 {
      font-family: Nunito Sans;
      font-style: normal;
      font-weight: 800;
      font-size: 20px;
      line-height: 27px;
      text-align: center;
      color: #596278;
      margin-top: 26px;
    }
  }

  .detail h1::before {
    content: "";
    width: 100px;
    height: 2px;
    background: #b6bbc5;
    position: absolute;
    padding: 1px;
    left: 20%;
    top: 36.5%;
  }
  .detail h1::after {
    content: "";
    width: 100px;
    height: 2px;
    background: #b6bbc5;
    position: absolute;
    padding: 1px;
    right: 20%;
    top: 36.5%;
  }

  .detail__secend {
    h1 {
      font-family: Nunito Sans;
      font-style: normal;
      font-weight: 800;
      font-size: 20px;
      line-height: 27px;
      text-align: center;
      color: #596278;
      margin-top: 26px;
    }
  }

  .detail__secend h1::before {
    content: "";
    width: 100px;
    height: 2px;
    background: #b6bbc5;
    position: absolute;
    padding: 1px;
    left: 20%;
    top: 34.4%;
  }
  .detail__secend h1::after {
    content: "";
    width: 100px;
    height: 2px;
    background: #b6bbc5;
    position: absolute;
    padding: 1px;
    right: 20%;
    top: 34.4%;
  }

  .signUp__name {
    display: flex;

    input {
      background: #ffffff;
      border: 1.5px solid #dbe0eb;
      box-sizing: border-box;
      border-radius: 4px;
      width: 100%;
      height: 45px;
      margin-right: 10px;
      padding-left: 20px;
      outline: none;
      margin-top: 24px;
    }
  }
  .signUp__process {
    input {
      background: #ffffff;
      border: 1.5px solid #dbe0eb;
      box-sizing: border-box;
      border-radius: 4px;
      width: 100%;
      height: 45px;
      display: block;
      outline: none;
      padding-left: 20px;
    }
  }

  .phone__inputs {
    .phoneInput {
      background: #ffffff;
      border: 1.5px solid #dbe0eb;
      box-sizing: border-box;
      border-radius: 4px;
      width: 100%;
      height: 45px;
      margin-top: 10px;
      outline: none;
      padding-left: 20px;
      display: flex;
      align-items: center;
    }
    input {
      background: #ffffff;
      border: 1.5px solid #dbe0eb;
      box-sizing: border-box;
      border-radius: 4px;
      width: 100%;
      height: 45px;
      display: block;
      outline: none;
      padding-left: 20px;
    }
  }

  .signup__mail__proc {
    margin-top: 10px;
  }
  .terms__checkbox {
    display: flex;
    margin-top: 26px;
    align-items: center;
    h5 {
      font-family: Manrope;
      font-style: normal;
      font-weight: normal;
      font-size: 18px;
      line-height: 25px;
      letter-spacing: 0.217059px;
      color: #393f4d;
      margin: 0;
      padding-left: 13.17px;
    }
    a {
      text-decoration: none;
      font-family: Manrope;
      font-style: normal;
      font-size: 18px;
      line-height: 25px;
      letter-spacing: 0.217059px;
      color: #1239ff;
      font-weight: 500;
    }
  }

  button.signUp__btn {
    background: #1239ff;
    border-radius: 4px;
    font-family: Manrope;
    font-style: normal;
    font-weight: 800;
    font-size: 18px;
    line-height: 25px;
    color: #ffffff;
    width: 100%;
    height: 50px;
    border: none;
    outline: none;
    margin-top: 50px;
  }
  p.wrapper__footer {
    font-family: Manrope;
    font-style: normal;
    font-weight: normal;
    font-size: 18px;
    line-height: 25px;
    letter-spacing: 0.217059px;
    color: #393f4d;
    margin-top: 41px;
    a {
      text-decoration: none;
      font-family: Manrope;
      font-style: normal;
      /* font-weight: normal; */
      font-size: 18px;
      line-height: 25px;
      letter-spacing: 0.217059px;
      color: #1239ff;
      font-weight: 700;
    }
  }

  @media screen and (max-width: 768px) {
    .sign__up_wrapper {
      width: 100% !important;
      margin: auto;
      height: 1000px !important;
      background: #ffffff;
      border-radius: 21px;
      padding-top: 200px;
      text-align: left;
      padding: 25px 25px;
      z-index: 999;
      transform: translateY(140px);
    }

    .sign__up_method {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      margin-top: 40px;
    }

    .signUp__type_btn {
      display: flex;
    }

    .signUp__type {
      /* position: relative; */
      h1 {
        font-family: Nunito Sans;
        font-style: normal;
        font-weight: 800;
        font-size: 20px;
        line-height: 27px;
        text-align: center;
        color: #596278;
        margin-top: 37px;
      }
      button {
        background: #ffffff;
        border: 1.5px solid #6300ff;
        box-sizing: border-box;
        border-radius: 4px;
        outline: none;
        width: 219px;
        height: 45px;
        margin-right: 10px;
        margin-top: 24px;
        font-family: Manrope;
        font-style: normal;
        font-weight: bold;
        font-size: 20px;
        line-height: 27px;
        text-align: center;
        color: #596278;
      }
    }

    .signup__mail__proc {
      margin-top: 10px;
    }
    .terms__checkbox {
      display: flex;
      margin-top: 26px;
      align-items: center;
      h5 {
        font-family: Manrope;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 25px;
        letter-spacing: 0.217059px;
        color: #393f4d;
        margin: 0;
        padding-left: 13.17px;
      }
      a {
        text-decoration: none;
        font-family: Manrope;
        font-style: normal;
        font-size: 15px;
        line-height: 25px;
        letter-spacing: 0.217059px;
        color: #1239ff;
        font-weight: 500;
      }
    }

    p.wrapper__footer {
      font-family: Manrope;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 25px;
      letter-spacing: 0.217059px;
      color: #393f4d;
      margin-top: 41px;
      margin-bottom: 41px;
      a {
        text-decoration: none;
        font-family: Manrope;
        font-style: normal;
        /* font-weight: normal; */
        font-size: 16px;
        line-height: 25px;
        letter-spacing: 0.217059px;
        color: #1239ff;
        font-weight: 700;
      }
    }

    .detail h1::before {
      content: "";
      width: 100px;
      height: 2px;
      background: #b6bbc5;
      position: absolute;
      padding: 1px;
      left: 12%;
      top: 29.5%;
    }
    .detail h1::after {
      content: "";
      width: 100px;
      height: 2px;
      background: #b6bbc5;
      position: absolute;
      padding: 1px;
      right: 12%;
      top: 29.5%;
    }
    .detail__secend h1::before {
      content: "";
      width: 100px;
      height: 2px;
      background: #b6bbc5;
      position: absolute;
      padding: 1px;
      left: 12%;
      top: 29.4%;
    }
    .detail__secend h1::after {
      content: "";
      width: 100px;
      height: 2px;
      background: #b6bbc5;
      position: absolute;
      padding: 1px;
      right: 12%;
      top: 29.4%;
    }

    .signUp__type h1::before {
      content: "";
      width: 101px;
      height: 2px;
      background: #b6bbc5;
      position: absolute;
      padding: 1px;
      left: 35px;
      top: 13px;
    }
    .signUp__type h1::after {
      content: "";
      width: 101px;
      height: 2px;
      background: #b6bbc5;
      position: absolute;
      padding: 1px;
      right: 35px;
      top: 13px;
    }
  }
`;

export default SignUp;
